import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useGetAtvTokenQuery } from 'src/api/atv/atvApi';
import { setYodleeConfig } from 'src/features/transfer/yodleeConfigSlice';
import { RootState } from 'src/state/store';

/**
 * Shared hook for initializing Yodlee FastLink.
 * Handles fetching the ATV token, dispatching config to the store,
 * managing FastLink initialization state, and cleaning up the container on unmount.
 */
export const useYodleeInit = () => {
  const [isFastLinkInitialized, setIsFastLinkInitialized] = useState(false);
  const { data: yodleeData } = useGetAtvTokenQuery();
  const dispatch = useDispatch();

  const { YodleeUrl, configName, obAppName } = useSelector(
    (state: RootState) => state.yodleeConfig,
  );

  useEffect(() => {
    if (yodleeData) {
      dispatch(setYodleeConfig(yodleeData));
    }
  }, [yodleeData, dispatch]);

  useEffect(() => {
    if (!isFastLinkInitialized) {
      setIsFastLinkInitialized(true);
    }

    return () => {
      const fastLinkContainer = document.getElementById('container-fastlink');
      if (fastLinkContainer) {
        fastLinkContainer.innerHTML = '';
      }
    };
  }, [isFastLinkInitialized]);

  return {
    isFastLinkInitialized,
    yodleeData,
    YodleeUrl,
    configName,
    obAppName,
  };
};
